/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InviteCode interface.
 */
export function instanceOfInviteCode(value) {
    if (!("code" in value) || value.code === undefined)
        return false;
    return true;
}
export function InviteCodeFromJSON(json) {
    return InviteCodeFromJSONTyped(json, false);
}
export function InviteCodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        code: json.code,
        usedBy: json.usedBy == null ? undefined : json.usedBy,
    };
}
export function InviteCodeToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        code: value.code,
        usedBy: value.usedBy,
    };
}
